import { alpha } from '@mui/material/styles';

import { NAVIGATION_ITEM_VARIANT_MAP } from 'applications/GSP/layouts/MainLayout/components/Sidebar/constants';

import type { Theme } from '@mui/material/styles';
import type { NavigationItem } from 'applications/GSP/layouts/MainLayout/components/Sidebar/types';

interface GetBackgroundColorArgs {
  opened?: boolean;
  theme: Theme;
  sidebarType: NavigationItem['sidebarType'];
}

export const getBackgroundColor = ({
  theme,
  opened,
  sidebarType,
}: GetBackgroundColorArgs) => {
  if (!opened) {
    return 'inherit';
  }

  return alpha(
    theme.palette[NAVIGATION_ITEM_VARIANT_MAP[sidebarType]].dark,
    theme.palette.action.selectedOpacity,
  );
};
